
import { defineComponent, onMounted, PropType, ref, toRef, watch } from "vue";
import { ITabConfig } from "@/interfaces/iTabConfig";
export default defineComponent({
  name: "vz-tabs",
  props: {
    value: { type: Boolean, default: false },
    direction: { type: String, default: "rtl" },
    type: { type: String, default: "" },
    title: { type: String, default: "" },
    tabs: { type: Object as PropType<ITabConfig[]>, required: true },
  },
  setup(props) {
    const selectedTab = ref<string>("");
    const tabs = toRef(props, "tabs");
    onMounted(() => {
      selectedTab.value = tabs.value?.[0]?.name ?? "";
    });
    watch(
      tabs,
      (newValue) => {
        selectedTab.value = newValue?.[0]?.name ?? "";
      },
      { deep: true }
    );
    return {
      selectedTab,
    };
  },
});
